import * as React from 'react'
import * as cn from 'classnames'

// Helpers from classnames
type ClassValue =
    | string
    | number
    | ClassDictionary
    | ClassArray
    | undefined
    | null
    | false
interface ClassArray extends Array<ClassValue> {}
interface ClassDictionary {
    [id: string]: boolean | undefined | null
}

export interface BaseComponentProps extends React.Props<any> {
    className?: string
}

export const extractClassObjectFromProps = (
    props: BaseComponentProps
): ClassDictionary => {
    const result: ClassDictionary  = {}

    if (props.className) {
        result[props.className] = true
    }

    return result
}

export const extractClassNamesFromProps = (
    props: BaseComponentProps,
    ...extraClasses: ClassValue[]
): string => {
    return cn(...extraClasses, extractClassObjectFromProps(props))
}
